<template>
  <GChart
    :type="type"
    :data="data"
    :options="chartOptions"
    :rootProps="{'data-testid': '1'}"
  />
</template>
<script lang="js">
import { GChart } from 'vue-google-charts'
import VueTypes from 'vue-types'
import { defineComponent } from 'vue'

export const GoogleBasicBarChart = defineComponent({
  name: 'GoogleBasicBarChart',
  components: {
    GChart
  },
  data () {
    return {
      chartOptions: {
        title: this.title,
        width: this.width,
        height: this.height,
        chartArea: { width: this.chartArea },
        hAxis: {
          title: 'Total',
          minValue: 0
        },
        vAxis: {
          title: 'City'
        }
      }
    }
  },
  methods: {},
  props: {
    type: VueTypes.string.def('BarChart'),
    width: VueTypes.string.def('100%'),
    height: VueTypes.number.def(300),
    data: VueTypes.array,
    title: VueTypes.string.def('Chart'),
    chartArea: VueTypes.string.def('50%')
  }
})

export default GoogleBasicBarChart
</script>
